import { CoreMappingsState } from './core-mappings-state.model';

export const INITIAL_CORE_MAPPINGS_STATE: CoreMappingsState = {
  buyers: null,
  buyersStatus: 'idle',
  uploadStatus: 'idle',
  uploadSuccessMessage: null,
  uploadError: null,
  downloadStatus: 'idle',
  downloadError: null,
};
